import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_10 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "btn-group float-end" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-header" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-4 col-sm-6" }
const _hoisted_21 = { class: "stat-card bg-primary" }
const _hoisted_22 = { class: "stat-icon" }
const _hoisted_23 = { class: "stat-content" }
const _hoisted_24 = { class: "col-md-4 col-sm-6" }
const _hoisted_25 = { class: "stat-card bg-success" }
const _hoisted_26 = { class: "stat-icon" }
const _hoisted_27 = { class: "stat-content" }
const _hoisted_28 = { class: "col-md-4 col-sm-6" }
const _hoisted_29 = { class: "stat-card bg-info" }
const _hoisted_30 = { class: "stat-icon" }
const _hoisted_31 = { class: "stat-content" }
const _hoisted_32 = { class: "row mt-3" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = {
  class: "progress mb-2",
  style: {"height":"30px"}
}
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = {
  class: "progress mb-2",
  style: {"height":"30px"}
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "card" }
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "table table-borderless" }
const _hoisted_42 = { class: "text-primary" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "card" }
const _hoisted_45 = {
  key: 0,
  class: "card-body"
}
const _hoisted_46 = { class: "table table-borderless" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = {
  key: 0,
  class: "card-body"
}
const _hoisted_51 = { class: "table table-borderless" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "card" }
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "table table-borderless" }
const _hoisted_56 = {
  key: 1,
  class: "row"
}
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "card" }
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = { class: "table-responsive" }
const _hoisted_61 = { class: "table" }
const _hoisted_62 = {
  key: 2,
  class: "row"
}
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = { class: "card" }
const _hoisted_65 = { class: "card-body" }
const _hoisted_66 = { class: "table-responsive" }
const _hoisted_67 = { class: "table" }
const _hoisted_68 = {
  key: 0,
  class: "badge badge-info me-1"
}
const _hoisted_69 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_70 = { class: "list-unstyled mb-0" }
const _hoisted_71 = {
  key: 3,
  class: "row"
}
const _hoisted_72 = { class: "col-12" }
const _hoisted_73 = { class: "card" }
const _hoisted_74 = { class: "card-body" }
const _hoisted_75 = { class: "card border" }
const _hoisted_76 = { class: "card-header bg-light" }
const _hoisted_77 = { class: "row align-items-center" }
const _hoisted_78 = { class: "col-md-3" }
const _hoisted_79 = { class: "mb-0 text-dark" }
const _hoisted_80 = { class: "text-muted" }
const _hoisted_81 = { class: "mt-1" }
const _hoisted_82 = {
  key: 0,
  class: "badge badge-warning badge-sm"
}
const _hoisted_83 = {
  key: 1,
  class: "badge badge-info badge-sm ms-1"
}
const _hoisted_84 = { class: "col-md-2" }
const _hoisted_85 = { class: "mt-1" }
const _hoisted_86 = { class: "text-muted" }
const _hoisted_87 = { class: "col-md-3" }
const _hoisted_88 = { class: "progress" }
const _hoisted_89 = { class: "col-md-2" }
const _hoisted_90 = { class: "text-center" }
const _hoisted_91 = { class: "col-md-2" }
const _hoisted_92 = { class: "text-center" }
const _hoisted_93 = {
  key: 0,
  class: "badge badge-secondary"
}
const _hoisted_94 = {
  key: 1,
  class: "d-block text-warning"
}
const _hoisted_95 = { class: "card-body" }
const _hoisted_96 = { class: "row mb-3" }
const _hoisted_97 = { class: "col-md-6" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_100 = { class: "table table-sm" }
const _hoisted_101 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_102 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_103 = { class: "badge badge-warning badge-sm" }
const _hoisted_104 = {
  key: 0,
  class: "badge badge-info badge-sm ms-1"
}
const _hoisted_105 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_106 = { class: "text-muted" }
const _hoisted_107 = {
  key: 0,
  class: "badge badge-success badge-sm"
}
const _hoisted_108 = {
  key: 1,
  class: "badge badge-info badge-sm"
}
const _hoisted_109 = {
  key: 2,
  class: "badge badge-warning badge-sm"
}
const _hoisted_110 = { class: "mt-1" }
const _hoisted_111 = {
  key: 0,
  class: "badge badge-primary badge-sm"
}
const _hoisted_112 = {
  key: 1,
  class: "badge badge-danger badge-sm"
}
const _hoisted_113 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_114 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_115 = { key: 1 }
const _hoisted_116 = {
  key: 0,
  class: "badge badge-secondary"
}
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = { key: 2 }
const _hoisted_121 = {
  key: 0,
  class: "text-center"
}
const _hoisted_122 = { class: "text-muted" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "text-info" }
const _hoisted_125 = {
  key: 1,
  class: "text-center"
}
const _hoisted_126 = {
  key: 1,
  class: "text-muted text-center py-3"
}
const _hoisted_127 = {
  key: 4,
  class: "row"
}
const _hoisted_128 = { class: "col-12" }
const _hoisted_129 = { class: "card" }
const _hoisted_130 = { class: "card-body" }
const _hoisted_131 = { class: "table-responsive" }
const _hoisted_132 = { class: "table table-sm" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "col-12" }
const _hoisted_135 = { class: "card" }
const _hoisted_136 = { class: "card-body" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = { class: "col-md-3" }
const _hoisted_139 = { class: "col-md-3" }
const _hoisted_140 = { class: "col-md-3" }
const _hoisted_141 = { class: "col-md-3" }
const _hoisted_142 = {
  key: 2,
  class: "container-fluid"
}
const _hoisted_143 = { class: "text-center p-5" }

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";
import { kytChainService } from "@/services/kytChainService";
import type { KytDetail } from "@/types/kyt-chain";


export default /*@__PURE__*/_defineComponent({
  __name: 'kyt-detail',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const toast = useToast();

// Get parameters from route
const logNo = ref<string>(route.params.logNo as string);
const kytId = ref<string>(route.params.kytId as string);

// Reactive data
const loading = ref(false);
const kytDetail = ref<KytDetail | null>(null);

// Methods
const fetchKytDetail = async () => {
  loading.value = true;
  try {
    const response = await kytChainService.getKytDetail(logNo.value, kytId.value);
    if (response.success) {
      kytDetail.value = response.data.kyt;
    } else {
      toast.error(response.message || "Failed to fetch KYT details");
    }
  } catch (error) {
    console.error("Error fetching KYT details:", error);
    toast.error("Error fetching KYT details");
  } finally {
    loading.value = false;
  }
};

const refreshData = () => {
  fetchKytDetail();
};

const goBack = () => {
  router.push(`/kyt-chain/logs/${logNo.value}/kyts`);
};

const exportData = async () => {
  try {
    const blob = await kytChainService.exportLogData(logNo.value);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `kyt-detail-${logNo.value}-${kytId.value}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    toast.success("Data exported successfully");
  } catch (error) {
    console.error("Export error:", error);
    toast.error("Failed to export data");
  }
};

const getKytStatusBadgeClass = (status: string) => {
  switch (status.toLowerCase()) {
    case "pending":
      return "badge-warning";
    case "approved":
      return "badge-success";
    case "completed":
      return "badge-primary";
    case "closed":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const getSubCategoryStatusBadgeClass = (status: string) => {
  switch (status.toLowerCase()) {
    case "pending":
      return "badge-warning";
    case "in-progress":
      return "badge-info";
    case "completed":
      return "badge-success";
    case "closed":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const getProgressBarClass = (percentage: number) => {
  if (percentage < 30) return "bg-danger";
  if (percentage < 70) return "bg-warning";
  return "bg-success";
};

const parseContactPerson = (contactPersonStr: string) => {
  try {
    // The contact_person is a string representation of an object
    // We need to parse it safely
    if (!contactPersonStr) return null;

    // Try to extract the values using regex since it's not valid JSON
    const nameMatch = contactPersonStr.match(/name:\s*'([^']*)'/);
    const designationMatch = contactPersonStr.match(/designation:\s*'([^']*)'/);
    const phoneMatch = contactPersonStr.match(/phone:\s*'([^']*)'/);
    const altPhoneMatch = contactPersonStr.match(/altPhone:\s*'([^']*)'/);
    const emailMatch = contactPersonStr.match(/email:\s*'([^']*)'/);

    return {
      name: nameMatch ? nameMatch[1] : "",
      designation: designationMatch ? designationMatch[1] : "",
      phone: phoneMatch ? phoneMatch[1] : "",
      altPhone: altPhoneMatch ? altPhoneMatch[1] : "",
      email: emailMatch ? emailMatch[1] : "",
    };
  } catch (error) {
    console.error("Error parsing contact person:", error);
    return null;
  }
};

// Chain-related helper methods
const getKytGeneration = () => {
  // Since we don't have cascade info in the current response, we'll assume this is generation 1
  // In a real implementation, this would come from the API response
  return 1;
};

const getKytPosition = () => {
  return "Current KYT in chain";
};

const getChainGeneration = () => {
  return getKytGeneration();
};

const getChainStatus = () => {
  if (!kytDetail.value) return "Unknown";

  if (kytDetail.value.isCompleted) return "Chain Complete";
  if (hasIncompleteWork()) return "Chain Active";
  return "Chain In Progress";
};

const getChainStatusBadge = () => {
  const status = getChainStatus();
  switch (status) {
    case "Chain Complete":
      return "badge-success";
    case "Chain Active":
      return "badge-warning";
    default:
      return "badge-info";
  }
};

const getOriginalWorkCompleted = () => {
  if (!kytDetail.value?.comprehensiveStats) return 0;
  return kytDetail.value.comprehensiveStats.overallCompletion;
};

const getCascadedAssignments = () => {
  if (!kytDetail.value?.subCategories) return 0;

  return kytDetail.value.subCategories.reduce((total, subCat) => {
    return (
      total +
      (subCat.assignments?.filter((a) => a.cascadeInfo?.cascadeGeneration > 1).length ||
        0)
    );
  }, 0);
};

const getIncompleteAssignments = () => {
  if (!kytDetail.value?.comprehensiveStats) return 0;
  return kytDetail.value.comprehensiveStats.pendingAssignments;
};

const getChainProgressBarClass = (percentage: number) => {
  if (percentage >= 90) return "bg-success";
  if (percentage >= 70) return "bg-info";
  if (percentage >= 50) return "bg-warning";
  return "bg-danger";
};

const hasIncompleteWork = () => {
  if (!kytDetail.value?.subCategories) return false;

  return kytDetail.value.subCategories.some((subCat) =>
    subCat.assignments?.some((assignment) => !assignment.isCompletedWork)
  );
};

const isCascadedSubCategory = (subCategory: any) => {
  return subCategory.cascadeInfo?.cascadeGeneration > 1;
};

const isOriginalAssignment = (assignment: any) => {
  return !assignment.cascadeInfo || assignment.cascadeInfo.cascadeGeneration <= 1;
};

const isCascadedAssignment = (assignment: any) => {
  return assignment.cascadeInfo?.cascadeGeneration > 1;
};

const getPriorityBadgeClass = (priority: string) => {
  switch (priority.toLowerCase()) {
    case "high":
      return "badge-danger";
    case "medium":
      return "badge-warning";
    case "low":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  } catch (error) {
    return dateString;
  }
};

const viewChainOverview = () => {
  router.push(`/kyt-chain/logs/${logNo.value}/kyts`);
};

const createNextKyt = () => {
  // This would trigger the creation of a new KYT with incomplete work
  // Implementation would depend on your API
  console.log("Creating next KYT for incomplete work...");
  toast.info("Feature coming soon: Create next KYT with incomplete work");
};

// Lifecycle
onMounted(() => {
  fetchKytDetail();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-6" }, [
            _createElementVNode("h3", null, "KYT Detail")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ol", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/kyt-chain/logs" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("KYT Logs", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: `/kyt-chain/logs/${logNo.value}/kyts`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(logNo.value), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("li", { class: "breadcrumb-item active" }, "KYT Detail", -1))
            ])
          ])
        ])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "text-center p-5" }, [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ]),
            _createElementVNode("p", { class: "mt-3" }, "Loading KYT details...")
          ], -1)
        ]))]))
      : (kytDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: goBack,
                    class: "btn btn-secondary"
                  }, [
                    _createVNode(_component_vue_feather, {
                      type: "arrow-left",
                      class: "me-1"
                    }),
                    _cache[5] || (_cache[5] = _createTextVNode(" Back to Chain ", -1))
                  ]),
                  _createElementVNode("button", {
                    onClick: refreshData,
                    class: "btn btn-primary"
                  }, [
                    _createVNode(_component_vue_feather, {
                      type: "refresh-cw",
                      class: "me-1"
                    }),
                    _cache[6] || (_cache[6] = _createTextVNode(" Refresh ", -1))
                  ]),
                  _createElementVNode("button", {
                    onClick: exportData,
                    class: "btn btn-success"
                  }, [
                    _createVNode(_component_vue_feather, {
                      type: "download",
                      class: "me-1"
                    }),
                    _cache[7] || (_cache[7] = _createTextVNode(" Export ", -1))
                  ])
                ])
              ])
            ]),
            (kytDetail.value.comprehensiveStats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("h5", null, [
                          _createVNode(_component_vue_feather, {
                            type: "bar-chart-2",
                            class: "me-2"
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode(" Current KYT Statistics ", -1))
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-muted" }, "Statistics for this specific KYT only", -1))
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_vue_feather, { type: "layers" })
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("h4", null, _toDisplayString(kytDetail.value.comprehensiveStats.totalSubCategories), 1),
                                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Sub Categories", -1)),
                                _cache[11] || (_cache[11] = _createElementVNode("small", { class: "d-block" }, "In this KYT", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_vue_feather, { type: "check-circle" })
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("h4", null, _toDisplayString(kytDetail.value.comprehensiveStats.completedSubCategories), 1),
                                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Completed", -1)),
                                _cache[13] || (_cache[13] = _createElementVNode("small", { class: "d-block" }, "Sub Categories", -1))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_vue_feather, { type: "briefcase" })
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("h4", null, _toDisplayString(kytDetail.value.comprehensiveStats.totalAssignments), 1),
                                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Assignments", -1)),
                                _cache[15] || (_cache[15] = _createElementVNode("small", { class: "d-block" }, "Active in this KYT", -1))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _cache[16] || (_cache[16] = _createElementVNode("h6", null, "Current KYT Completion", -1)),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["progress-bar", 
                      getProgressBarClass(kytDetail.value.comprehensiveStats.overallCompletion)
                    ]),
                                style: _normalizeStyle({
                      width: kytDetail.value.comprehensiveStats.overallCompletion + '%',
                    })
                              }, _toDisplayString(kytDetail.value.comprehensiveStats.overallCompletion) + "% ", 7)
                            ]),
                            _cache[17] || (_cache[17] = _createElementVNode("small", { class: "text-muted" }, "Progress of current KYT only", -1))
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[18] || (_cache[18] = _createElementVNode("h6", null, "Verification Rate", -1)),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", {
                                class: "progress-bar bg-info",
                                style: _normalizeStyle({
                      width: kytDetail.value.comprehensiveStats.verificationRate + '%',
                    })
                              }, _toDisplayString(kytDetail.value.comprehensiveStats.verificationRate) + "% ", 5)
                            ]),
                            _cache[19] || (_cache[19] = _createElementVNode("small", { class: "text-muted" }, "Work verified in this KYT", -1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Basic Information")
                  ], -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("table", _hoisted_41, [
                      _createElementVNode("tr", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Log Number:")
                        ], -1)),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(logNo.value), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Site Name:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(kytDetail.value.siteName), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Status:")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", getKytStatusBadgeClass(kytDetail.value.status)])
                          }, _toDisplayString(kytDetail.value.status.toUpperCase()), 3)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[23] || (_cache[23] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Completed:")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", kytDetail.value.isCompleted ? 'badge-success' : 'badge-warning'])
                          }, _toDisplayString(kytDetail.value.isCompleted ? "Yes" : "No"), 3)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "NFD:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(kytDetail.value.formattedDates?.NFD || kytDetail.value.NFD), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[25] || (_cache[25] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Work Description:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(kytDetail.value.workDescription), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Type of CDW:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(kytDetail.value.typeOfCDW), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Priority:")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", kytDetail.value.isPriority ? 'badge-danger' : 'badge-secondary'])
                          }, _toDisplayString(kytDetail.value.isPriority ? "High" : "Normal"), 3)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Site Information")
                  ], -1)),
                  (kytDetail.value.siteId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("table", _hoisted_46, [
                          _createElementVNode("tr", null, [
                            _cache[29] || (_cache[29] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Site Name:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.siteId.siteName), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[30] || (_cache[30] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Address:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.siteId.siteAddress), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[31] || (_cache[31] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Site Address:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.siteAddress), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[32] || (_cache[32] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Landmark:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.landmark || "N/A"), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Coordinates:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.siteLat) + ", " + _toDisplayString(kytDetail.value.siteLong), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Website:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.websiteUrl || "N/A"), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Assigned Employee")
                  ], -1)),
                  (kytDetail.value.empId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("table", _hoisted_51, [
                          _createElementVNode("tr", null, [
                            _cache[36] || (_cache[36] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Name:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.empId.employeeName), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[37] || (_cache[37] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Code:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.empId.employeeCode), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[38] || (_cache[38] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Email:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.empId.email || "N/A"), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Type of CDW:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.typeOfCDW), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[40] || (_cache[40] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Work Duration:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.workDuration) + " hours", 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Travel Duration:")
                            ], -1)),
                            _createElementVNode("td", null, _toDisplayString(kytDetail.value.travelDuration) + " hours", 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Contact Information")
                  ], -1)),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("table", _hoisted_55, [
                      _createElementVNode("tr", null, [
                        _cache[43] || (_cache[43] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Contact Person:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(parseContactPerson(kytDetail.value.contact_person)?.name || "N/A"), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[44] || (_cache[44] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Designation:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(parseContactPerson(kytDetail.value.contact_person)?.designation || "N/A"), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[45] || (_cache[45] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Phone:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(parseContactPerson(kytDetail.value.contact_person)?.phone || "N/A"), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[46] || (_cache[46] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Alt Phone:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(parseContactPerson(kytDetail.value.contact_person)?.altPhone || "N/A"), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[47] || (_cache[47] = _createElementVNode("td", null, [
                          _createElementVNode("strong", null, "Email:")
                        ], -1)),
                        _createElementVNode("td", null, _toDisplayString(parseContactPerson(kytDetail.value.contact_person)?.email || "N/A"), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            (kytDetail.value.assignedManagers && kytDetail.value.assignedManagers.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _cache[50] || (_cache[50] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", null, "Assigned Managers")
                      ], -1)),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("table", _hoisted_61, [
                            _cache[49] || (_cache[49] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Manager Name"),
                                _createElementVNode("th", null, "Employee Code"),
                                _createElementVNode("th", null, "Assigned Date")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kytDetail.value.assignedManagers, (manager) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: manager.empId._id
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(manager.empId.employeeName), 1),
                                  _createElementVNode("td", null, _toDisplayString(manager.empId.employeeCode), 1),
                                  _createElementVNode("td", null, _toDisplayString(manager.date), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (kytDetail.value.followUps && kytDetail.value.followUps.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", null, "Follow-ups")
                      ], -1)),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("table", _hoisted_67, [
                            _cache[51] || (_cache[51] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Type"),
                                _createElementVNode("th", null, "NFD"),
                                _createElementVNode("th", null, "Rating"),
                                _createElementVNode("th", null, "Meeting Report")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kytDetail.value.followUps, (followUp, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, [
                                    (followUp.isCall)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Call"))
                                      : _createCommentVNode("", true),
                                    (followUp.isVisit)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, "Visit"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(followUp.NFD), 1),
                                  _createElementVNode("td", null, _toDisplayString(followUp.rating), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("ul", _hoisted_70, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(followUp.meetingReport, (report, idx) => {
                                        return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(report), 1))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (kytDetail.value.subCategories && kytDetail.value.subCategories.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _cache[68] || (_cache[68] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", null, "Sub Categories")
                      ], -1)),
                      _createElementVNode("div", _hoisted_74, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kytDetail.value.subCategories, (subCategory) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subCategory._id,
                            class: "mb-4"
                          }, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _createElementVNode("h6", _hoisted_79, _toDisplayString(subCategory.subCategoryName), 1),
                                    _createElementVNode("small", _hoisted_80, _toDisplayString(subCategory.subCategoryLogNo), 1),
                                    _createElementVNode("div", _hoisted_81, [
                                      (isCascadedSubCategory(subCategory))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                            _createVNode(_component_vue_feather, {
                                              type: "arrow-right",
                                              size: "12",
                                              class: "me-1"
                                            }),
                                            _cache[53] || (_cache[53] = _createTextVNode(" Cascaded ", -1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (subCategory.cascadeInfo?.cascadeGeneration)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_83, " Gen " + _toDisplayString(subCategory.cascadeInfo.cascadeGeneration), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_84, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["badge", getSubCategoryStatusBadgeClass(subCategory.status)])
                                    }, _toDisplayString(subCategory.status), 3),
                                    _createElementVNode("div", _hoisted_85, [
                                      _createElementVNode("small", _hoisted_86, _toDisplayString(formatDate(subCategory.subCategoryDate)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("div", _hoisted_88, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["progress-bar", getProgressBarClass(subCategory.completionPercentage)]),
                                        style: _normalizeStyle({ width: subCategory.completionPercentage + '%' })
                                      }, _toDisplayString(subCategory.completionPercentage) + "% ", 7)
                                    ]),
                                    _cache[54] || (_cache[54] = _createElementVNode("small", { class: "text-muted" }, "Completion Rate", -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createElementVNode("strong", null, _toDisplayString(subCategory.stats?.completedAssignments || 0) + "/" + _toDisplayString(subCategory.stats?.totalAssignments || 0), 1),
                                      _cache[55] || (_cache[55] = _createElementVNode("small", { class: "d-block text-muted" }, "Assignments", -1))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("div", _hoisted_92, [
                                      (subCategory.cascadeInfo?.totalOriginalEmployees)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(subCategory.cascadeInfo.completedEmployees) + "/" + _toDisplayString(subCategory.cascadeInfo.totalOriginalEmployees) + " Original ", 1))
                                        : _createCommentVNode("", true),
                                      (subCategory.cascadeInfo?.isPartialCascade)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_94, " Partial Cascade "))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _cache[56] || (_cache[56] = _createElementVNode("h6", null, "Problem", -1)),
                                    _createElementVNode("p", null, _toDisplayString(subCategory.problem || "No problem described"), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_98, [
                                    _cache[57] || (_cache[57] = _createElementVNode("h6", null, "Solution", -1)),
                                    _createElementVNode("p", null, _toDisplayString(subCategory.solution || "No solution provided"), 1)
                                  ])
                                ]),
                                _cache[67] || (_cache[67] = _createElementVNode("h6", null, "Assignments", -1)),
                                (subCategory.assignments && subCategory.assignments.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                      _createElementVNode("table", _hoisted_100, [
                                        _cache[66] || (_cache[66] = _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "Assignment ID"),
                                            _createElementVNode("th", null, "Employee"),
                                            _createElementVNode("th", null, "Status"),
                                            _createElementVNode("th", null, "Work Description"),
                                            _createElementVNode("th", null, "Quality Score"),
                                            _createElementVNode("th", null, "Photos"),
                                            _createElementVNode("th", null, "Dates"),
                                            _createElementVNode("th", null, "Chain Info")
                                          ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategory.assignments, (assignment) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: assignment._id
                                            }, [
                                              _createElementVNode("td", null, [
                                                _createTextVNode(_toDisplayString(assignment.assignmentId) + " ", 1),
                                                (isOriginalAssignment(assignment))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [...(_cache[58] || (_cache[58] = [
                                                      _createElementVNode("span", { class: "badge badge-primary badge-sm" }, "Original", -1)
                                                    ]))]))
                                                  : (isCascadedAssignment(assignment))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                        _createElementVNode("span", _hoisted_103, [
                                                          _createVNode(_component_vue_feather, {
                                                            type: "arrow-right",
                                                            size: "10",
                                                            class: "me-1"
                                                          }),
                                                          _cache[59] || (_cache[59] = _createTextVNode(" Cascaded ", -1))
                                                        ]),
                                                        (assignment.cascadeInfo?.cascadeGeneration)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_104, " Gen " + _toDisplayString(assignment.cascadeInfo.cascadeGeneration), 1))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("strong", null, _toDisplayString(assignment.employeeId.employeeName), 1),
                                                  _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                                                  _createElementVNode("small", null, _toDisplayString(assignment.employeeId.employeeCode), 1)
                                                ]),
                                                (assignment.assignedBy)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                      _createElementVNode("small", _hoisted_106, " Assigned by: " + _toDisplayString(assignment.assignedBy.employeeName), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("div", null, [
                                                  (assignment.isCompletedWork)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_107, "Completed"))
                                                    : (assignment.workStarted)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_108, "Started"))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_109, "Pending"))
                                                ]),
                                                _createElementVNode("div", _hoisted_110, [
                                                  (assignment.isVerified)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Verified"))
                                                    : _createCommentVNode("", true),
                                                  (assignment.requiresRework)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_112, "Needs Rework"))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                (
                                assignment.priority && assignment.priority !== 'medium'
                              )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["badge", getPriorityBadgeClass(assignment.priority)])
                                                      }, _toDisplayString(assignment.priority.toUpperCase()), 3)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(assignment.assignmentDetails.workDescription || "N/A"), 1),
                                              _createElementVNode("td", null, [
                                                (assignment.workStatus.qualityScore)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(assignment.workStatus.qualityScore) + "/10 ", 1))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_115, "N/A"))
                                              ]),
                                              _createElementVNode("td", null, [
                                                (assignment.photos && assignment.photos.length > 0)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_116, _toDisplayString(assignment.photos.length) + " photos ", 1))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_117, "No photos"))
                                              ]),
                                              _createElementVNode("td", null, [
                                                _createElementVNode("small", null, [
                                                  _createElementVNode("div", null, [
                                                    _cache[61] || (_cache[61] = _createElementVNode("strong", null, "Assigned:", -1)),
                                                    _createTextVNode(" " + _toDisplayString(assignment.formattedDates.assignedDate), 1)
                                                  ]),
                                                  (assignment.formattedDates.workStartedAt)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                        _cache[62] || (_cache[62] = _createElementVNode("strong", null, "Started:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(assignment.formattedDates.workStartedAt), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (assignment.formattedDates.workCompletedAt)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                        _cache[63] || (_cache[63] = _createElementVNode("strong", null, "Completed:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(assignment.formattedDates.workCompletedAt), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (assignment.formattedDates.verifiedAt)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                        _cache[64] || (_cache[64] = _createElementVNode("strong", null, "Verified:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(assignment.formattedDates.verifiedAt), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("td", null, [
                                                (assignment.cascadeInfo)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                                      _createElementVNode("small", _hoisted_122, " Gen " + _toDisplayString(assignment.cascadeInfo.cascadeGeneration || 1), 1),
                                                      (assignment.cascadeInfo.totalOriginalAssignees > 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                            _createElementVNode("small", _hoisted_124, _toDisplayString(assignment.cascadeInfo.remainingAssignees) + "/" + _toDisplayString(assignment.cascadeInfo.totalOriginalAssignees) + " remaining ", 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_125, [...(_cache[65] || (_cache[65] = [
                                                      _createElementVNode("small", { class: "text-muted" }, "Original", -1)
                                                    ]))]))
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_126, " No assignments found "))
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
        kytDetail.value.kytData &&
        kytDetail.value.kytData.manpower &&
        kytDetail.value.kytData.manpower.length > 0
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("div", _hoisted_129, [
                      _cache[70] || (_cache[70] = _createElementVNode("div", { class: "card-header" }, [
                        _createElementVNode("h5", null, "KYT Data - Manpower")
                      ], -1)),
                      _createElementVNode("div", _hoisted_130, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kytDetail.value.kytData.manpower, (manpowerData) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: manpowerData._id,
                            class: "mb-3"
                          }, [
                            _createElementVNode("h6", null, _toDisplayString(manpowerData.category) + " - " + _toDisplayString(manpowerData.logNo), 1),
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("table", _hoisted_132, [
                                _cache[69] || (_cache[69] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Sub Category"),
                                    _createElementVNode("th", null, "Date"),
                                    _createElementVNode("th", null, "Problem"),
                                    _createElementVNode("th", null, "Solution"),
                                    _createElementVNode("th", null, "Status"),
                                    _createElementVNode("th", null, "Completion"),
                                    _createElementVNode("th", null, "Assignments")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manpowerData.subCategories, (subCatData, index) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                      _createElementVNode("td", null, _toDisplayString(subCatData.subCategory), 1),
                                      _createElementVNode("td", null, _toDisplayString(subCatData.subCategoryDate), 1),
                                      _createElementVNode("td", null, _toDisplayString(subCatData.problem), 1),
                                      _createElementVNode("td", null, _toDisplayString(subCatData.solution), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["badge", getSubCategoryStatusBadgeClass(subCatData.status)])
                                        }, _toDisplayString(subCatData.status), 3)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(subCatData.completionPercentage) + "%", 1),
                                      _createElementVNode("td", null, _toDisplayString(subCatData.completedAssignments) + "/" + _toDisplayString(subCatData.totalAssignments), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _cache[75] || (_cache[75] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h5", null, "Important Dates")
                  ], -1)),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("div", _hoisted_137, [
                      _createElementVNode("div", _hoisted_138, [
                        _cache[71] || (_cache[71] = _createElementVNode("h6", null, "Created At", -1)),
                        _createElementVNode("p", null, _toDisplayString(kytDetail.value.formattedDates?.createdAt), 1)
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _cache[72] || (_cache[72] = _createElementVNode("h6", null, "Updated At", -1)),
                        _createElementVNode("p", null, _toDisplayString(kytDetail.value.formattedDates?.updatedAt), 1)
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        _cache[73] || (_cache[73] = _createElementVNode("h6", null, "NFD", -1)),
                        _createElementVNode("p", null, _toDisplayString(kytDetail.value.formattedDates?.NFD), 1)
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _cache[74] || (_cache[74] = _createElementVNode("h6", null, "Closed At", -1)),
                        _createElementVNode("p", null, _toDisplayString(kytDetail.value.formattedDates?.closedAt || "Not closed"), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
              _createElementVNode("div", _hoisted_143, [
                _createVNode(_component_vue_feather, {
                  type: "alert-circle",
                  size: "48",
                  class: "text-danger mb-3"
                }),
                _cache[77] || (_cache[77] = _createElementVNode("h5", null, "KYT not found", -1)),
                _cache[78] || (_cache[78] = _createElementVNode("p", { class: "text-muted" }, "The requested KYT could not be found.", -1)),
                _createElementVNode("button", {
                  onClick: goBack,
                  class: "btn btn-primary"
                }, [
                  _createVNode(_component_vue_feather, {
                    type: "arrow-left",
                    class: "me-1"
                  }),
                  _cache[76] || (_cache[76] = _createTextVNode(" Go Back ", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})